// extracted by mini-css-extract-plugin
export default {"webTopNav":"PlasmicWebTopNav_webTopNav__1KqSA","pageTitleSlot":"PlasmicWebTopNav_pageTitleSlot__HC3nO","topnavButtonsSlot":"PlasmicWebTopNav_topnavButtonsSlot__PBsa5"};